export const authLocalStorageKey = 'auth';
